/**
 * Each event name should be used with an `event` tag,
 * which validates the value and prevents incorrect names.
 */
import { event } from 'shared/experiments/utils/event'

export const CSW_PRODUCT_CLICK = event`Click on product of CSW`
export const CSW_SHOW_MORE_CLICK = event`Click on show more button of CSW`
export const CSW_SHOW_ALL_CLICK = event`Click on show all button of CSW`
export const CSW_ARROW_CLICK = event`Click on arrow of CSW`

export const SERP_PRODUCT_DETAIL_CLICK = event`SERP - Click on product detail link`
export const SERP_FILTER_APPLY = event`SERP - Apply filter`
export const SERP_PAGINATION = event`SERP - Pagination`

export const EVENT_CLICK_ON_PRODUCT_VARIANT = event`NEW SERP - Click on product variant`
export const EVENT_CLICK_ADD_TO_CART = event`NEW SERP - Click on add-2-cart CTA`
export const EVENT_CLICK_ON_PRODUCT_DETAIL = event`NEW SERP - Click on product detail link`

export const PDP_ADD_TO_CART = event`PDP - Click on add-2-cart CTA`
export const PDP_CLICK_ON_VARIANT = event`PDP - Click on variant`
